import React from "react";
import styles from "./PreviewV3.module.css";

export default function PreviewHeader({ swmsData }) {

  const sections = (swmsData && swmsData.sections) || {};
  const projectSection = sections.document_project_details || {};
  const projectDetails = projectSection.data || {};
  const orgDetails = projectDetails.org_details || {};
  const orgName = orgDetails.name || "";
  const orgLetter = orgName ? orgName.charAt(0) : "";
  const swmsNumber = projectDetails.swms_number || "";
  const swmsVersion = projectDetails.swms_version;
  const revNumber = (swmsVersion && swmsVersion.slice(1)) || "1";

  return (
    <div className={styles.PreviewDocBand} id="prv-doc-band" style={{ borderBottom: "4px solid #D85C5C" }}>
      <div className={styles.PreviewDocBandLetter}>
        <div className={styles.PreviewDocBandMark}>{orgLetter}</div>
        <div>
          <div className={styles.PreviewDocBandName}>{orgName}</div>
          <div className={styles.PreviewDocBandSub} style={{ color: "#F1B8B8", fontWeight: 600 }}>Safe Work Method Statement</div>
        </div>
      </div>
      <div className={styles.PreviewDocBandRight}>
        <div className={styles.PreviewDocBandNo}>
          <span
            style={{
              display: "inline-block",
              verticalAlign: "2px",
              background: "#D85C5C",
              color: "#fff",
              fontSize: "10px",
              fontWeight: 800,
              letterSpacing: "0.8px",
              padding: "3px 9px",
              borderRadius: "999px",
              marginRight: "9px",
              lineHeight: 1
            }}
          >
            SWMS
          </span>
          {swmsNumber}
        </div>
        <div style={{ fontWeight: 600, color: "#b8a8ef" }}>Rev {revNumber} &middot; Pending</div>
        <div style={{ fontWeight: 600, color: "#b8a8ef" }}>Controlled — Uncontrolled if Printed</div>
      </div>
    </div>
  )
}